import { render, staticRenderFns } from "./agLinkDetail.vue?vue&type=template&id=346f5b7f&"
import script from "./agLinkDetail.vue?vue&type=script&lang=ts&"
export * from "./agLinkDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports